


































































































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import IssuePropertiesForm from "@/Ui-Components/Issue/IssueForm.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";

import { IssueService, IIssueService } from "../../BusinessServices/issue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaIssueBase from "../Base/ParticaIssueBase.vue";
import { IssuePropertiesDTO, IssuePropertiesDTOStatus, IssuePropertiesDTOVisibility, IssueModel } from "../../Generated/ParticaAPI";
import { IIssueConversionService } from "../../BusinessServices/issueconversion";
@Component(
	{
		name: "ParticaIssue",
		components: {
			ParticaError,
			ButtonList,
			IssuePropertiesForm,
			ParticaRowContainer,
			ParticaColumnContainer,
			ParticaCard,
			ParticaView
		}
	})
export default class ParticaIssue extends ParticaIssueBase {
	private data: IssuePropertiesDTO = new IssuePropertiesDTO();
	private urls: string[] = [];
	private issue: IssueModel = new IssueModel();
	private issueService: IIssueService;
	private issueConversionService: IIssueConversionService;
	@Prop() private id: number;
	private flipbookbuttons: ButtonConfig[] = [
		{ label: "Table Contents", action: eParticaAction.ISSUE_TOC, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Wordsmart", action: eParticaAction.ISSUE_WORDSMART, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Folio", action: eParticaAction.ISSUE_FOLIO, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Metadata", action: eParticaAction.ISSUE_METADATA, type: ButtonType.Normal } as ButtonConfig,
	];
	private advancedbuttons: ButtonConfig[] = [
		{ label: "Replace PDF", action: eParticaAction.ISSUE_REPLACE_PDF, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Restart Conversion", action: eParticaAction.ISSUE_RESTART_CONVERSION, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Viewer JSON Config", action: eParticaAction.ISSUE_VIEWERCONFIG, type: ButtonType.Normal } as ButtonConfig,
	];
	private articlebuttons: ButtonConfig[] = [
		{ label: "Extract", action: eParticaAction.ISSUE_EXTRACT, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Manage", action: eParticaAction.ISSUE_MANAGE_ARTICLES, type: ButtonType.Normal } as ButtonConfig,
	];
	private formbuttons: ButtonConfig[] = [
		{ label: "Update Issue", action: eParticaAction.ISSUE_SAVE, type: ButtonType.OK } as ButtonConfig,
		{ label: "Delete Issue", action: eParticaAction.ISSUE_DELETE_CONFIRM, type: ButtonType.Cancel } as ButtonConfig,
		{ label: "Publish", action: eParticaAction.ISSUE_PUBLISH, type: ButtonType.Highlight } as ButtonConfig,
	];


	private isDisabled() {
		if (!this.data) {
			return true;
		}
		if (this.stateconfig.admin === false) {
			return true;
		}
		return this.data.status === IssuePropertiesDTOStatus.Processing || this.data.status === IssuePropertiesDTOStatus.Conversionfailed;
	}

	private getSeoLink() {
		return `${this.urls[0].substring(0, this.urls[0].indexOf("/", 10))}/seo/issue/${this.issue.urlFragment}_i${this.id}`;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ISSUE_SAVE: {
					await this.issueService.UpdateIssue(this.data);
					this.ShowSnackbar("Issue updated. Republish issue to see these changes in the viewer.");
					await this.init();
					break;
				}
				case eParticaAction.ISSUE_DELETE_CONFIRM: {
					this.dialog.action = eParticaAction.ISSUE_DELETE;
					this.dialog.title = `Confirm deletion of '${this.issue.name}'`;
					this.dialog.message2 = "Are you sure you want to delete this issue. The issues will not be available on this website after deleting.";
					this.dialog.show = true;
					break;
				}
				case eParticaAction.ISSUE_DELETE: {
					await this.issueService.DeleteIssue(this.id);
					this.ShowSnackbar("Issue delete successful.");
					if (this.issue !== undefined && this.issue.publicationId !== undefined) {
						this.navigate("title", { id: this.issue.publicationId.toString() });
					}
					break;
				}
				case eParticaAction.ISSUE_PUBLISH: {
					if (this.data.visibility === IssuePropertiesDTOVisibility.NotVisible) {
						await this.issueService.PublishIssue(this.id, 1);
						this.formbuttons[2].label = "Unpublish";
						this.ShowSnackbar("Issue made live, It may take a couple of minutes to appear on the website.");
					} else {
						await this.issueService.PublishIssue(this.id, 0);
						this.formbuttons[2].label = "Publish";
						this.ShowSnackbar("Issue removed from website, It may take a couple of minutes to reflect on the website.");
					}

					await this.init();
					break;
				}
				case eParticaAction.ISSUE_STATUS: {
					this.navigate("issuestatus", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_VIEWERCONFIG: {
					this.navigate("issueviewerconfig", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_CONVERSION_SETTINGS: {
					this.navigate("issueconversion", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_RESTART_CONVERSION: {
					await this.issueConversionService.restartIssue(this.id);
					this.ShowSnackbar("Issue conversion restarted.");
					break;
				}
				case eParticaAction.ISSUE_SAVE: {
					throw new Error("Not Implemented.");
					break;
				}
				case eParticaAction.ISSUE_METADATA: {
					this.navigate("issuemanagemeta", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_REPLACE_PDF: {
					this.navigate("issuepdfreplace", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_MANAGE_ARTICLES: {
					this.navigate("issuemanagearticles", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_EXTRACT: {
					this.navigate("issueextraction", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_TOC: {
					this.navigate("issuetoc", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_WORDSMART: {
					this.navigate("issuepagewordsmart", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_FOLIO: {
					this.navigate("issuefolio", { id: this.id.toString() });
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	private isProcessed(): boolean {
		if (this.data.status === IssuePropertiesDTOStatus.Processed) {
			return true;
		}
		return false;
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Home";
		await this.init();
		this.breadcrumbs[1].disabled = true;
		this.breadcrumbs.pop();
		if (this.stateconfig.admin === true) {
			this.advancedbuttons.push({ label: "Conversion Log", action: eParticaAction.ISSUE_CONVERSION_SETTINGS, type: ButtonType.Normal } as ButtonConfig);
			this.advancedbuttons.push({ label: "Status", action: eParticaAction.ISSUE_STATUS, type: ButtonType.Normal } as ButtonConfig);
		}

	}

	private async init() {
		try {
			this.LoadingStart();
			this.issueService = this.particaServices.getIssueService();
			this.data = await this.issueService.getIssueProperties(this.id);
			this.issue = await this.issueService.getIssue(this.id);
			this.urls = await this.issueService.getIssueDomains(this.id);
			await this.getIssueNav(this.id);

			if (this.data.visibility === IssuePropertiesDTOVisibility.Visible) {
				this.formbuttons[2].label = "Unpublish";
			}
			if (this.isDisabled() === true) {
				this.formbuttons[2].status = ButtonStatus.Disabled;
			}
			this.issueConversionService = this.particaServices.getIssueConversionService();

			if (this.data.status === IssuePropertiesDTOStatus.Processing) {
				this.ShowSnackbar("This issue is processing. Some options have been removed until processing is complete.");
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
